import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import { API_BASE_URL } from "../config";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenParam = params.get("token");
    const emailParam = params.get("email");

    if (!tokenParam || !emailParam) {
      setMessage("Invalid or missing token/email.");
    } else {
      setToken(tokenParam);
      setEmail(emailParam);
    }
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/Home/ResetPassword`, {
        email,
        token,
        newPassword: password,
      });

      setMessage(response.data.message || "Password reset successful.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Reset failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
<>
 
    <br/><br/>

    <div className="new-login-container">
      <div className="new-login-box">
      <h2 className="new-login-title">Reset Password</h2>
      <form onSubmit={handleReset} className="new-login-form">
          {/* Email Input */}
          <div className="new-input-group">
            <label htmlFor="username">New Password</label>
            <div className="new-input-wrapper">
              <i className="fas fa-key" />
              <input
          type="password"
          placeholder="New Password"
          className="new-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        </div>
        </div>
        <div className="new-input-group">
            <label htmlFor="username">Confirm Password</label>
            <div className="new-input-wrapper">
            <i className="fas fa-key" />
        <input
          type="password"
          placeholder="Confirm Password"
           className="new-input"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
            </div>
          </div>

        
          <button type="submit" className="new-login-btn" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
</button>

         
        </form>
        {message && <p className="mt-4 text-center text-sm text-gray-700">{message}</p>}
      </div>
    </div>
    <br/><br/>
    </>

    // <div className="max-w-md mx-auto mt-20 p-4 border rounded shadow-sm bg-white">
    //   <h2 className="text-xl font-semibold mb-4">Reset Password</h2>
    //   <form onSubmit={handleReset}>
    //     <input
    //       type="password"
    //       placeholder="New Password"
    //       className="w-full p-2 border rounded mb-3"
    //       value={password}
    //       onChange={(e) => setPassword(e.target.value)}
    //       required
    //     />
    //     <input
    //       type="password"
    //       placeholder="Confirm Password"
    //       className="w-full p-2 border rounded mb-4"
    //       value={confirm}
    //       onChange={(e) => setConfirm(e.target.value)}
    //       required
    //     />
    //     <button
    //       type="submit"
    //       disabled={loading}
    //       className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
    //     >
    //       {loading ? "Resetting..." : "Reset Password"}
    //     </button>
    //   </form>
    //   {message && <p className="mt-4 text-center text-sm text-red-600">{message}</p>}
    // </div>
  );
};

export default ResetPassword;
